import React from "react";
import { DeprecatedUISharedButton } from "packages/ui-shared/components/Button/Button";
import {
  useTrackElementClicked,
  useTrackElementViewed
} from "packages/membership/tracking";
import {
  bodyDescription,
  bodyTitle,
  imageWrapper
} from "../../DiscoveryJourneyModal.css";
import type { SlideButtonActions } from "../../types";
import { baseTrackingValues } from "../../types";

export const WelcomeSlide: React.FC = () => {
  const { ref } = useTrackElementViewed({
    ...baseTrackingValues,
    payload: { locationDetails: "welcome_slide" }
  });

  return (
    <div ref={ref}>
      <img
        src="https://beautypie.bynder.com/asset/346a98a4-e020-4bb6-94f9-94a8040d0519/16_9_web/MEMBER_PERKS_DESK_WEB.jpg"
        alt="member-perks"
        className={imageWrapper}
      />

      <h2 className={bodyTitle}>
        Welcome To Your New & Improved Member Rewards
      </h2>
      <p className={bodyDescription}>
        We're SO happy you're here and want to help you get the most from your
        Beauty Pie membership. Click 'Continue' to find out how you can unlock
        rewards as you shop!
      </p>
    </div>
  );
};

export const WelcomeSlideCTA: React.FC<SlideButtonActions> = ({
  goToNextSlide
}) => {
  const { elementClicked } = useTrackElementClicked(baseTrackingValues);

  const handleClick = () => {
    goToNextSlide?.();
    elementClicked({
      details: "continue",
      locationDetails: "welcome_slide"
    });
  };

  return (
    <DeprecatedUISharedButton
      variant="primary"
      type="button"
      fullWidth
      aria-label="Continue"
      handleClick={handleClick}
    >
      Continue
    </DeprecatedUISharedButton>
  );
};
